import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { getJobCards } from '../../api/jobCards';
import Color from '../../common/Color';
import СolorPicker from '../../common/СolorPicker';
import { path } from 'ramda';

export class ArchiveEdit extends Component {

  constructor(props) {
    super(props);
    this.changeColor = this.changeColor.bind(this);
  }

  changeColor() { }

  render() {
    return (
      <div style={{ paddingBottom: '25px' }}>
          <div className="card rounded">
            <div className="card-header rounded-top">
              Archive Edit
            </div>
            <div className="card-block">
              <div className="clearfix mb-3">
                <div>
                  <button className={'btn btn-danger btn-outline float-right'} style={{ marginLeft: '10px' }}>
                    <i className="fa fa-remove"></i>
                    <span style={{ paddingLeft: '3px' }}>Cancel</span>
                  </button>
                  <button className={'btn btn-success btn-outline float-right'} onClick={this.saveData}>
                    <i className="fa fa-check"></i>
                    <span style={{ paddingLeft: '3px' }}>Save</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveEdit);



// WEBPACK FOOTER //
// ./src/containers/ArchiveEdit/index.js